BaseDialog = App.loadClass "core::reports/BaseDialog"

class exports.Audit_Dialog extends BaseDialog
    init: () ->
        super()
        @layoutUrl = 'backend/portal/audit/dialog'
        @subHandlers =
            'Audit_Report':
                'class': 'portal::handlers/audit/Audit_SubHandler'

        @defaultSub = 'Audit_Report'
        @createDialog()


    afterLoadLayout: (selector, data) ->
        @openDialog()
        ths = this

        @msg = @dialog.find('.message_writer')

        @audit_subHandler = @createSubHandler(@defaultSub)
        if @audit_subHandler
            @audit_subHandler.init(data)

        $(@parent.layoutSelector).find('.apply-filters').bind 'click', () =>
            @audit_subHandler.refreshReport()

        @dialog.delegate '.excel-btn', 'click', () =>
            ths = this
            url = ths.audit_subHandler.excelUrl + "?" + $.param { query: ko.toJSON(@filters.jsonize()) }
            window.open(url, '_blank')

        $(window).unbind('finished_report_load modal_resized').bind 'finished_report_load modal_resized', debounce (e) =>
            ths.resize()

    resize: () ->
        element = @dialog.find('.audit-container')
        element.resizr()

        @audit_subHandler.currentOutput.resizeTable()
